import { Link } from 'gatsby';
import React, { useContext, useEffect } from 'react';
import { AppContextInterface } from '../../custom-types';
import { AppCtx } from '../../layouts';
import { categoryUrl } from '../layout/BurgerMenu';

function CategoryBadge({ title, slug, is_featured_card = false }: { title: string; slug?: string; is_featured_card?: boolean }) {
  const { appContext } = useContext<AppContextInterface>(AppCtx);


  const [isSafari, setIsSafari] = React.useState(false);
  
  useEffect(() => {
    let agent = parseUserAgent(navigator.userAgent)
    setIsSafari(agent);
  //console.log('navigator.userAgent',agent);
  }, [])


  const parseUserAgent = (pathname) => {
    const isSafari = /^((?!chrome).)*safari/i.test(pathname);
    return isSafari;
  };

  return (
    <React.Fragment>
      {slug ? (
        <Link to={categoryUrl(appContext?.currentLanguage, slug)}>
          <span className={`inline-block	bg-omooma-pink-dark-primary px-2 lg:text-lg text-base text-white rounded  ltr:font-headline rtl:text-right  ${isSafari ? 'rtl:font-bodyEn' : 'rtl:font-bodyAr'}`}>
            {title}
          </span>
        </Link>
      ) : (
        <div className={`flex ${appContext?.currentLanguage == 'ar' && is_featured_card ? 'justify-end' : ''}`}>
          <span className={`inline-block	bg-omooma-pink-dark-primary px-2 lg:text-lg text-base text-white rounded  ltr:font-headline rtl:text-right self-left  ${isSafari ? 'rtl:font-bodyEn' : 'rtl:font-bodyAr'}`}>
            {title}
          </span>
        </div>
      )}
    </React.Fragment>
  );
}

export default CategoryBadge;
